import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Report, RowActions } from '../../../../admin/report/report';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';
import { DeleteMemberService } from '../../services/delete-member.service';
import { GetTeamMangementService } from '../../services/get-team-management.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-member-management',
  templateUrl: './member-management.component.html',
  styleUrls: ['./member-management.component.scss']
})
export class MemberManagementComponent implements OnInit {
  totalNumberOfRecords: number = 0;
  teamManagementReportData: any[] = [];
  token = 'token';
  requestBody: Report = {};
  loading = false;
  displayedColumns: any[] = [
    'firstName',
    'lastName',
    'email',
    'roleName'
  ];

  displayTableColumns = {};

  rowActions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa-edit',
    },
  ];
  reportName: string = '';

  constructor(public teamManagementService: GetTeamMangementService,
    private deleteMemeberService: DeleteMemberService,
    public dialog: MatDialog,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    try {
      this.teamManagementService.activateLoader();
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10
      };
      this.updateTable();
    } catch (err) {
      console.log(err);
    }
  }

  loadArContent() {
    this.reportName = 'إدارة الفريق';
    this.translate.use('ar');

    this.displayTableColumns = {
      'firstName': 'الإسم الأول',
      'lastName': 'الإسم الأخير',
      'email': 'البريد الإليكترونى',
      'roleName': 'الدور',
    };
  }

  loadEnContent() {
    this.reportName = 'Team Mangement';
    this.translate.use('en');

    this.displayTableColumns = {
      'firstName': 'First Name',
      'lastName': 'Last Name',
      'email': 'Email',
      'roleName': 'Role',
    };
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.teamManagementService.loader().subscribe((val: any) => this.loading = val);
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.teamManagementService.loader().subscribe((val: any) => this.loading = val);
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.teamManagementService.loader().subscribe((val: any) => this.loading = val);
    }
    this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.teamManagementService.loader().subscribe((val: any) => this.loading = val);
  }

  async updateTable() {
    this.teamManagementService.activateLoader();
    this.teamManagementService.setParams(this.requestBody);
    const report = await this.teamManagementService.make();
    console.log(report);
    this.teamManagementReportData = report.body.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }


  onRowAction(event: any) {
    if (event.action === 'delete') {
      // console.log(event.key)
      this.deleteTeamMember(event.key);
    }
    if (event.action === 'edit') {
      // console.log(event.key)
      this.router.navigate(['/seller/team/edit-member/', event.key]);
    }
  }

  async deleteTeamMember(token: string) {
    // console.log(id);
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: this.translate.instant('Sellers.Products.SureWantDelete'),
          question: true,
          confirmTextMessage: this.translate.instant('Sellers.Products.Yes'),
          cancelTextMessage: this.translate.instant('Sellers.Products.No')
        }
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.deleteMemeberService.setParams({ token });
      await this.deleteMemeberService.make();
      this.updateTable();
      this.teamManagementService.loader().subscribe((val: any) => this.loading = val);
    } catch (err) {
      console.log(err);
    }
  }

}
